import {
  useCallback, useRef, useState, useEffect,
} from 'react';
import { DirectLine, IBotConnection } from 'botframework-directlinejs';
import { IAdsCopilotProps } from '../types';

export function useSesId({ onInitDirectLine, botServiceConfig, onStartOverClick }: Pick<IAdsCopilotProps, 'onInitDirectLine' | 'botServiceConfig' | 'onStartOverClick'>) {
  const [sesId, setSesId] = useState(botServiceConfig.sesId || 0);
  const dlRef = useRef<IBotConnection | null>(null);

  useEffect(() => {
    if (botServiceConfig.sesId != null) {
      setSesId(botServiceConfig.sesId);
    }
  }, [botServiceConfig.sesId]);

  const finalOnInitDirectLine = useCallback<NonNullable<IAdsCopilotProps['onInitDirectLine']>>((dl, userId, userName) => {
    if (onInitDirectLine != null) {
      onInitDirectLine(dl, userId, userName);
    }
    dlRef.current = dl;
  }, [onInitDirectLine]);

  const refreshSesId = useCallback(() => {
    if (botServiceConfig.sesId == null) {
      setSesId(prev => prev + 1);
    }
    if (onStartOverClick) {
      onStartOverClick();
    }
  }, [botServiceConfig.sesId, onStartOverClick]);

  const onClickStartOver = useCallback(() => new Promise<void>((resolve) => {
    const handleComplete = () => {
      refreshSesId();
      resolve();
    };

    if (dlRef.current && (dlRef.current as any)?.token) {
      dlRef.current.postActivity({
        type: 'endOfConversation' as any,
        from: {
          name: botServiceConfig.username,
          id: botServiceConfig.userid,
        },
      }).subscribe(
        handleComplete,
        handleComplete
      );
    } else {
      handleComplete();
    }
  }), [botServiceConfig.userid, botServiceConfig.username, refreshSesId]);

  return {
    sesId,
    onClickStartOver,
    onInitDirectLine: finalOnInitDirectLine,
    directLine: dlRef.current as DirectLine | undefined,
  };
}
